import { COST_PARAMETERS_STORAGE_KEYS } from "../../../constants/storageConstants";

export const OPERATIONS_MAINTENANCE_TYPES = [
  { constantsKey: "LED_UPS", storageKey: "ledUps" },
  { constantsKey: "LIGHTING_LEASE", storageKey: "lightingLease" },
  { constantsKey: "LIGHTING", storageKey: "lighting" },
  { constantsKey: "POWER", storageKey: "power" },
  {
    constantsKey: "PUSHBUTTON_APS_DETECTION",
    storageKey: "pushbuttonApsDetection",
  },
  {
    constantsKey: "ROUNDABOUT_LANDSCAPING",
    storageKey: "roundaboutLandscaping",
  },
  {
    constantsKey: "SIGNAL_CONTROLLER",
    storageKey: "signalController",
  },
  {
    constantsKey: "SIGNAL_MAINTENANCE",
    storageKey: "signalMaintenance",
  },
  {
    constantsKey: "SIGNAL_RETIMING",
    storageKey: "signalRetiming",
  },
  { isAlwaysShown: true, storageKey: "other" },
  { isAlwaysShown: true, storageKey: "other2" },
];

const { DISCOUNT_RATE, COST_PER_CRASH, VALUE_OF_TIME } =
  window.PENN_DOT_CONSTANTS;

const valueOfTimeSource = "From the 2021 TTI Urban Mobility Report";

export const TIME_CRASHES_DISCOUNT_RATE_FIELDS = [
  {
    category: "N/A",
    fieldName: "discountRate",
    globalDefaultValue: DISCOUNT_RATE,
    notesFieldName: "discountRateNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.DISCOUNT_RATE,
    type: "Discount Rate",
    unit: "Percent",
  },
  {
    category: "Person (weekday)",
    fieldName: "personWeekday",
    globalDefaultValue: VALUE_OF_TIME.PERSON_WEEKDAY,
    notesFieldName: "personWeekdayNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.VALUE_OF_TIME,
    tooltipText: valueOfTimeSource,
    type: "Value of time",
    unit: "$ per person hour",
  },
  {
    category: "Person (weekend)",
    fieldName: "personWeekend",
    globalDefaultValue: VALUE_OF_TIME.PERSON_WEEKEND,
    notesFieldName: "personWeekendNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.VALUE_OF_TIME,
    tooltipText: valueOfTimeSource,
    type: "Value of time",
    unit: "$ per person hour",
  },
  {
    category: "Trucks",
    fieldName: "truck",
    globalDefaultValue: VALUE_OF_TIME.TRUCK,
    notesFieldName: "truckNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.VALUE_OF_TIME,
    tooltipText: valueOfTimeSource,
    type: "Value of time",
    unit: "$ per truck hour",
  },
  {
    category: "Fatal & injury crashes",
    fieldName: "fatalInjury",
    globalDefaultValue: COST_PER_CRASH.FATAL_AND_INJURY,
    notesFieldName: "fatalInjuryNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.COST_PER_CRASH,
    type: "Crashes",
    unit: "$ per crash",
  },
  {
    category: "Property damage only crashes",
    fieldName: "propertyDamageOnly",
    globalDefaultValue: COST_PER_CRASH.PROPERTY_DAMAGE_ONLY,
    notesFieldName: "propertyDamageOnlyNotes",
    storageKey: COST_PARAMETERS_STORAGE_KEYS.COST_PER_CRASH,
    type: "Crashes",
    unit: "$ per crash",
  },
];
